import useSWRImmutable from 'swr/immutable';
import Link from 'next/link';

import Slider from '../slider/Slider';

import type { BusinessDetails, Review } from '@/api/trustpilot/reviews';
import { Breakpoints } from '@/settings/breakpoints';
import TrustpilotReviewCard from '../collections/reviews/TrustpilotReviewCard';

type Response = { business: BusinessDetails; reviews: Review[] };

const breakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.3,
    spaceBetween: 15,
  },
  [Breakpoints.XXS]: {
    slidesPerView: 1.5,
    spaceBetween: 15,
  },
  [Breakpoints.XS]: {
    slidesPerView: 2.5,
    spaceBetween: 15,
  },
  [Breakpoints.LG]: {
    slidesPerView: 3,
    spaceBetween: 15,
  },
  [Breakpoints.XL]: {
    slidesPerView: 4,
    spaceBetween: 15,
  },
};

const RecentReviews = () => {
  const { data: reviews } = useSWRImmutable<Response>(
    '/api/trustpilot/reviews',
  );

  if (reviews == null) return null;

  return (
    <div>
      <div className="flex flex-col xxs:flex-row xxs:items-center xxs:justify-between">
        <h2 className="flex shrink-0 items-center text-lg font-semibold md:text-xl ">
          Most Recent Reviews
        </h2>
        <Link href={`/reviews`} passHref>
          <a className="flex items-center gap-2">
            <p className="text-xs font-extrabold lg:text-sm">
              See <span className="hidden lg:inline-block">all reviews</span>
              <span className="lg:hidden">more</span>
            </p>
            <div className="w-3 lg:block">
              <svg viewBox="0 0 100 100">
                <path
                  d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
                  transform="translate(100, 100) rotate(180) "
                />
              </svg>
            </div>
          </a>
        </Link>
      </div>

      <div className="mt-6">
        <div className="relative">
          <Slider breakpoints={breakpoints}>
            {reviews.reviews.map((r) => (
              <TrustpilotReviewCard review={r} key={`review_${r.id}`} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default RecentReviews;
